/**
 * This is a litte script to detect samsung browser into UA string
 * based on official documentation 
 * for more info about this go to https://developer.samsung.com/internet/user-agent-string-format.html
 */

const wordsToSearchOnUserAgentField = [
  'SamsungBrowser', // 2015 and later released devices
  // Exceptions: 
  'SM-N915G Build/KTU84P', // Samsung Internet for Android
  'SM-G925F Build/LRX22G', // Samsung Internet for Android 4.0
  'SM-Z130H', // Samsung Internet for Tizen Mobile | Tizen Mobile Web Application
  'SM-Z910F', // Tizen TV Web Application
];

export const DetectSamsungBrowser = (): boolean => {
  let isSamsungBrowser = false;
  for(let i = 0; i < wordsToSearchOnUserAgentField.length; i++) {
    if (navigator.userAgent.indexOf(wordsToSearchOnUserAgentField[i]) > - 1) {
      isSamsungBrowser = true;
      break;
    }
  }
  return isSamsungBrowser;
}